<template>
  <div class="main-container container-xxl">
    <titulo-grande texto="Notícias" posicao="left" />
    <div class="row">
      <Propaganda :midia="['/img/anuncios/1.jpg', '/img/anuncios/2.jpg']" nome_exibicao="Topo lista de notícias">
      </propaganda>
      <template v-if="listagem.length > 0">
        <BlocoNoticias id="noticias" v-for="n in listagem" :key="n.id" :descricao="n.titulo" :link="n.link_amistoso"
          :categoria="n.categoria" :img_noticia="n.imagem" :titulo="n.titulo" :ativa_placeholder="ativa_placeholder"
          class="animate__animated" />

        <nav aria-label="Paginação pt-5">
          <ul class="pagination mt-4 justify-content-center">
            <li :class="['page-item', (pagina <= 1 ? 'disabled' : '')]">
              <router-link class="page-link" @click="paginacao(pagina - 1)"
                :to="link_base + (pagina - 1)">Anterior</router-link>
            </li>
            <li class="page-item" v-for="(p, i) in qtd_paginas" :key="i">
              <router-link :class="['page-link', (pagina == p ? 'active' : '')]" @click="paginacao(p)"
                :to="link_base + p">{{ p }}</router-link>
            </li>
            <li :class="['page-item', (pagina == qtd_paginas || pagina == 0 ? 'disabled' : '')]">
              <router-link class="page-link" @click="paginacao(pagina + 1)"
                :to="link_base + (pagina + 1)">Próxima</router-link>
            </li>
          </ul>
        </nav>
      </template>
      <template v-else>
        <div class="row" v-if="ativa_placeholder">
          <BlocoNoticias id="noticias" v-for="(n, i) in 4" :key="i" :descricao="n.titulo" :link="n.link_amistoso"
            :categoria="n.categoria" :img_noticia="n.imagem" :titulo="n.titulo" :ativa_placeholder="ativa_placeholder"
            class="animate__animated" />
        </div>
        <div v-else class="alert alert-danger alert-lg text-center">Nenhuma notícia com a categoria "{{ categoria }}"
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import TituloGrande from '@/components/TituloGrande.vue'
import BlocoNoticias from '@/components/BlocoNoticias.vue'
import { filtro_loading, meta_default, muda_titulo } from '@/assets/js/functions'
import { api } from '@/services/api'
import Propaganda from '@/components/propaganda.vue'
export default {
  components: { TituloGrande, BlocoNoticias, Propaganda },
  name: 'Noticias',
  data() {
    return {
      listagem: 1,
      qtd_p_pag: 12,
      qtd_paginas: 0,
      pagina: 0,
      link_base: '/noticias/',
      categoria: '',
      ativa_placeholder: true,
    }
  },
  methods: {
    async lista_noticias() {
      filtro_loading()
      if (this.$route.params.cat == undefined) {
        var listagem = await api.post('news/list_site')
        this.link_base = '/noticias/'
      } else {
        this.link_base = '/noticias/cat/' + this.$route.params.cat + '/'
        var listagem = await api.post('news/list_site/0/0/' + this.$route.params.cat)
        muda_titulo({ title: 'Notícias - ' + this.$route.params.cat })
      }
      this.qtd_paginas = Math.ceil(listagem.length / this.qtd_p_pag)
      var param_pag = (this.$route.params.pag == undefined ? 1 : this.$route.params.pag)
      this.paginacao(param_pag)
    },
    async paginacao(pag = 1) {
      if (this.pagina != pag || this.categoria != this.$route.params.cat) {
        // filtro_loading()
        this.pagina = pag
        this.categoria = this.$route.params.cat
        if (this.$route.params.cat == undefined) {
          var url_api = 'news/list_site/' + this.qtd_p_pag + '/' + pag;
        } else {
          var url_api = 'news/list_site/' + this.qtd_p_pag + '/' + pag + '/' + this.$route.params.cat;
        }

        this.listagem = await api.post(url_api)
        this.ativa_placeholder = false
      }
      filtro_loading(false)
    },
    
  },
  updated() {
    this.lista_noticias()
  },
  mounted() {
    this.lista_noticias();
    muda_titulo({ title: 'Notícias' , meta: meta_default('Notícias')})
  },
}
</script>

<style scoped>
/*  */
</style>